import {UserManagementContext} from './_context'

export const UserManagementProvider = UserManagementContext.Provider